import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { NuveiInfo, OnboardingService } from '../../services/onboarding.service';
import { UtilsService } from 'projects/common/src/public-api';
import { Router } from "@angular/router";
import { ModalBehavior, ModalsService } from "../../../../../common/src/lib/services/modals.service";
import {
  ConfirmationDialog
} from "../../../../../common/src/lib/modals/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'app-banner',
  standalone: true,
  styleUrls: ['./banner.scss'],
  template: `
    <div [class]="'banner-wrapper justify-content-between ' + type">
      <div class="d-flex align-items-center gap--16">
        <ng-content select="[leading]"></ng-content>
        <ng-content select="[content]"></ng-content>
      </div>
      <ng-content select="[trailing]"></ng-content>
    </div>
  `
})
export class BannerComponent {

  @Input() type?: 'primary' | 'success' | 'warning' | 'error';

}
